import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';

import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';

import { DOCUMENT } from '@angular/common';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { FirestoreService } from '../../core/services/firestore.service';
import { Host } from 'src/app/core/models/host.models';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { HostService } from '../../core/services/host.service';
import { User } from 'src/app/core/models/auth.models';
import { flatMap } from 'rxjs/internal/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileComponent } from 'src/app/pages/user-profile/user-profile.component';
import { MyUser } from 'src/app/core/models/myUser.models';

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss']
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit, OnDestroy {

  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  user$: Observable<MyUser>;

  menuItems = [];

  listLang = [
    { text: 'Magyar', flag: 'assets/images/flags/hun.png', lang: 'hu' },
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
  ];

  hosts$: Observable<Host[]>;
  // role$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  // onDestroy$: BehaviorSubject<null> = new BehaviorSubject<null>(null);
  selectedHost: Host;

  // tslint:disable-next-line: max-line-length
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private eventService: EventService, private authService: AuthenticationService,
    public languageService: LanguageService, private modalService: NgbModal,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService,
    private firestore: FirestoreService,
    private hostService: HostService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {
    this.element = document.documentElement;

    // this.initialize();
    const userFromStorage = this.authService.currentUser();
    this.user$ = this.authService.getUser(userFromStorage.uid);

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    this.hosts$ = this.firestore.getList<Host>('hosts').pipe(
      map(hosts => {
        // console.log('gethosts', hosts);
        return hosts.map(host => {
          return this.authService.getUserRole(host?.id).pipe(
            map(role => {
              // console.log(host?.name, role);
              // this.role$.next(role);
              if (role) {
                // console.log('role', host, role);
                // ha van jogosultsága, akkor rá is állítjuk az elsőre
                const h = {...host, role};
                if (!this.selectedHost) {
                  // console.log('select', h);

                  this.selectHost(h);
                }
                return h;
              } else {
                return null;
              }
            })
          );
        })
      }),
      flatMap(hosts => combineLatest(hosts)),
      map(hosts => {
        const filtered = hosts.filter(h => h != null);
        return filtered;
      })
    );

    // this.hosts$ = this.firestore.getList<Host>('hosts').pipe(
    //   tap(hosts => {
    //    if (hosts?.length > 0 && !this.selectedHost) {

    //      this.selectHost(hosts[0]);
    //    }
    //   })
    // );//.pipe(takeUntil(this.onDestroy$));
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/account/login']);
  }

  /**
   * On menu click
   */
  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      if (window.innerWidth < 992) {
        nextEl.classList.toggle("show");
      }
    }
    return false;
  }

  selectHost(host) {
    if (this.selectedHost?.id != host?.id) {
      this.hostService.selectedHost$.next(host);
      this.initialize(host?.role);
    }
    this.selectedHost = host;
    // if (host?.id) {
      // console.log(this.route.url.value);
      // this.router.navigate([host.id], {relativeTo: this.route})
    // }
  }

  ngAfterViewInit() {
    this.topbarLight();
    this.activateMenu();
  }

  ngOnDestroy(): void {
    // this.onDestroy$.next(null);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById("topnav-menu-content")
                if(menuelement !== null )
                if(menuelement.classList.contains('show'))
                document
                    .getElementById("topnav-menu-content")
                    .classList.remove("show");
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  // onSettingsButtonClicked() {
  //   document.body.classList.toggle('right-bar-enabled');
  // }

  /**
   * Fullscreen method
   */
  // fullscreen() {
  //   document.body.classList.toggle('fullscreen-enable');
  //   if (
  //     !document.fullscreenElement && !this.element.mozFullScreenElement &&
  //     !this.element.webkitFullscreenElement) {
  //     if (this.element.requestFullscreen) {
  //       this.element.requestFullscreen();
  //     } else if (this.element.mozRequestFullScreen) {
  //       /* Firefox */
  //       this.element.mozRequestFullScreen();
  //     } else if (this.element.webkitRequestFullscreen) {
  //       /* Chrome, Safari and Opera */
  //       this.element.webkitRequestFullscreen();
  //     } else if (this.element.msRequestFullscreen) {
  //       /* IE/Edge */
  //       this.element.msRequestFullscreen();
  //     }
  //   } else {
  //     if (this.document.exitFullscreen) {
  //       this.document.exitFullscreen();
  //     } else if (this.document.mozCancelFullScreen) {
  //       /* Firefox */
  //       this.document.mozCancelFullScreen();
  //     } else if (this.document.webkitExitFullscreen) {
  //       /* Chrome, Safari and Opera */
  //       this.document.webkitExitFullscreen();
  //     } else if (this.document.msExitFullscreen) {
  //       /* IE/Edge */
  //       this.document.msExitFullscreen();
  //     }
  //   }
  // }

  /**
   * Topbar light
   */
  topbarLight() {
    document.body.setAttribute('data-topbar', 'light');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Set boxed width
   */
  // boxedWidth() {
  //   document.body.setAttribute('data-layout-size', 'boxed');
  //   document.body.setAttribute('data-topbar', 'dark');
  //   document.body.removeAttribute('data-layout-scrollable');
  // }

  /**
   * Colored header
   */
  coloredHeader() {
    document.body.setAttribute('data-topbar', 'colored');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-layout-scrollable');
  }

  scrollable() {
    document.body.removeAttribute('data-layout-size');
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Initialize
   */
  initialize(role: string): void {
    this.menuItems = [];
    // authservice getuserRole()

    let roleVal = 0;
    switch (role) {
      case 'sysAdmin':
        roleVal = 30;
        break;
      case 'hostAdmin':
        roleVal = 20;
        break;
      case 'user':
        roleVal = 10;
        break;
    }
    MENU.forEach(mi => {
      let menuItem = {...mi};
      menuItem.subItems = this.getSubItems(menuItem, roleVal);
      this.menuItems.push(menuItem);
    });
    // console.log(this.menuItems, role);



    // this.menuItems = MENU;

    //role függő menük hozzáadása, ha egy menün belül több féle role is lesz, akkor nem lesz jó így
    // this.authService.userIsSysAdmin().pipe(
    //   tap(isSysAdmin => {
    //     if (isSysAdmin) {
    //       MENU.forEach(mi => {
    //         const subItemsWithRole = this.getSubItemsWithRole(mi, 'sysAdmin');
    //         if (subItemsWithRole?.length) {
    //           const mm = {...mi, subItems: subItemsWithRole};
    //           this.menuItems.push(mm);
    //         }
    //       })
    //     }
    //   })
    // ).subscribe();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems?.length;
  }

  getSubItems(item: MenuItem, role: number) {
    /*
      role
      0 - nincs
      10 - user
      20 - host
      30 - sys
    */
    let subItems: any[] = [];
    item.subItems?.forEach(si => {
      if (!si.roles) {
        subItems.push(si);
      // } else if (role && si.roles.find(r => r === role)) {
      } else if (role && si.roles <= role) {
        subItems.push(si);
      }
    })
    return subItems;

  }

  showProfile(hosts: Host[], user: MyUser) {
    const modalRef = this.modalService.open(UserProfileComponent, {/*size: 'lg',*/ scrollable: true, windowClass: 'modal-holder'});
    modalRef.componentInstance.user = user;
    modalRef.componentInstance.hosts = hosts;
  }

}
